import _Wrap from '../_app/cuchillo/layout/Wrap';
import { gsap, Power2 } from "gsap";
import { GetBy } from '../_app/cuchillo/core/Element';

export default class Wrap extends _Wrap {
  static back = GetBy.class('back')[0];
  static options = {
    show: {
      duration: .2,
      delay: 0,
      ease: Power2.easeOut
    },
    hide: {
      duration: .2,
      delay: 0,
      ease: Power2.easeIn
    }
  }

  // .back lives outside #Main (see _building-billboard.scss / layout/default.njk)
  // so it doesn't fade with it automatically: mirror the same tween here.
  static show(__call, opts = {}) {
    super.show(__call, opts);

    gsap.to(this.back, {
      alpha: 1,
      duration: opts.duration || this.options.show.duration,
      delay: opts.delay || this.options.show.delay,
      ease: opts.ease || this.options.show.ease
    });
  }

  static hide(__call, opts = {}) {
    super.hide(__call, opts);

    gsap.to(this.back, {
      alpha: 0,
      duration: opts.duration || this.options.hide.duration,
      delay: opts.delay || this.options.hide.delay,
      ease: opts.ease || this.options.hide.ease
    });
  }
}


